/**
 * 导入axios请求工具
 * @module http
 */
import axios from '@/api/config/request'
/**
 * 导入基础API配置
 * @module index
 */
import { BASE_API } from './index'

/**
 * 获取验证码的函数
 * @param {Object} params
 * @param {AuthCodeEnum} params.useType - 验证码使用场景类型，取值为 AuthCodeEnum 中的值
 * @param {string} [params.mobile] - 手机号（与标识码二选一）
 * @param {string} [params.identifier] - 标识码（与手机号二选一）
 * @returns {Promise} - 返回一个Promise对象，包含验证码请求的结果
 */
export const getAuthCode = (params) => {
  const { useType, mobile, identifier } = params
  if (!useType) {
    return Promise.reject(new Error('验证码类型不能为空'))
  }
  if (!mobile && !identifier) {
    return Promise.reject(new Error('手机号和标识码需至少提供一个'))
  }

  return axios({ 
    url: `${BASE_API}/code/sim`,
    method: 'get',
    params
  })
}


/**
 * 验证码标识枚举，定义不同场景下的验证码类型
 * @constant
 */
export const AuthCodeEnum = Object.freeze({
  // 易缆网平台短信验证码登录
  LOGIN: 'SMS_475900826',
  // 易缆网平台账号注册
  REGISTER: 'SMS_475750852',
  // 易缆网账号激活获取验证码
  ACTIVATE: 'SMS_465371500',
  // 易缆网忘记密码找回密码/个人密码修改
  PASSWORD: 'SMS_475745885',
  // 易缆网换绑手机号-原手机号
  OLD_MOBILE: 'SMS_475745885',
  // 易缆网换绑手机号-新手机号
  NEW_MOBILE: 'SMS_475735937'
})
